module.exports = __webpack_public_path__ + "media/images/home/home_banner-9c750accc5529b6989048c0e56e3f6e0.png";